import type { CanvasItem } from "@bedrock/domain";

export const STACK_REVEAL_DURATION_MS = 460;
export const STACK_COLLAPSE_DURATION_MS = 320;

const STACK_REVEAL_PREFERRED_STEP_MS = 38;
const STACK_REVEAL_MAX_STAGGER_MS = 320;
const STACK_REVEAL_SETTLE_BUFFER_MS = 80;
const STACK_COLLAPSE_SETTLE_BUFFER_MS = 40;

export function orderedStackChildren(items: CanvasItem[], stackId: string): CanvasItem[] {
  return items
    .filter((item) => item.parentStackId === stackId)
    .sort((first, second) => first.zIndex - second.zIndex || first.createdAt - second.createdAt || first.id.localeCompare(second.id));
}

export function stackRevealDelay(index: number, itemCount: number): number {
  if (itemCount <= 1 || index <= 0) return 0;
  const step = Math.min(STACK_REVEAL_PREFERRED_STEP_MS, STACK_REVEAL_MAX_STAGGER_MS / (itemCount - 1));
  return Math.round(Math.min(index, itemCount - 1) * step);
}

export function stackCollapseDelay(index: number, itemCount: number): number {
  if (itemCount <= 1) return 0;
  return stackRevealDelay(Math.max(0, itemCount - 1 - Math.min(index, itemCount - 1)), itemCount);
}

export function stackRevealTotalDuration(itemCount: number): number {
  return STACK_REVEAL_DURATION_MS + stackRevealDelay(Math.max(0, itemCount - 1), itemCount) + STACK_REVEAL_SETTLE_BUFFER_MS;
}

export function stackCollapseTotalDuration(itemCount: number, motionReduced = false): number {
  if (motionReduced || itemCount <= 0) return 0;
  return STACK_COLLAPSE_DURATION_MS + stackCollapseDelay(0, itemCount) + STACK_COLLAPSE_SETTLE_BUFFER_MS;
}

export function stackRevealOrigin(item: CanvasItem, stack: CanvasItem): { x: number; y: number; rotation: number } {
  const openingCenterY = stack.y + Math.min(54, Math.max(30, stack.height * .27));
  return {
    x: stack.x + (stack.width - item.width) / 2,
    y: openingCenterY - item.height / 2,
    rotation: stack.rotation
  };
}
